// clipboardHelper.js
import store from '.././store';

export default function findBlocksByIds(ids) {
    const emailData = store.state.emailData;
    let result = [];

    function findBlocks(ids) {
        ids.forEach(id => {
            const block = JSON.parse(JSON.stringify(emailData[id]))
            if (block) {
                result.push({id, ...block});
                if (block.data.props.childrenIds && block.data.props.childrenIds.length > 0) {
                    findBlocks(block.data.props.childrenIds);
                }
                if (block.data.props.columns) {
                    block.data.props.columns.forEach(column => {
                        if (column.childrenIds && column.childrenIds.length > 0) {
                            findBlocks(column.childrenIds);
                        }
                    });}
            } 
        });
    }

    findBlocks(ids);
    return result;
}
